import { useQuery } from "@tanstack/react-query";
import { privateRequest } from "../utils/api";

// Query key for admin stats
export const ADMIN_STATS_QUERY_KEY = ["admin", "stats"];

// Function to fetch admin stats from the API
const fetchAdminStats = async () => {
  try {
    const response = await privateRequest.get("/admin/stats");
    return response.data.data; // Assuming the stats are in response.data.data
  } catch (error) {
    console.log(error)
  }
};

// Custom hook to fetch admin stats using TanStack Query
export const useAdminStats = () => {
  return useQuery({
    queryKey: ADMIN_STATS_QUERY_KEY,
    queryFn: fetchAdminStats,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });
};
